export default {
  warning:
    'This store is not assigned to a brand. In order for the system to work properly the store has to belong to one. Please add this store to a brand.',
  cta: 'Go to brands',
};
